import _implicitStylesheets from "./review.css";
import _implicitScopedStylesheets from "./review.scoped.css?scoped=true";
import _wdsAvatar from "wds/avatar";
import _wdsLink from "wds/link";
import _wdsPopoverTooltip from "wds/popoverTooltip";
import _wdsBadge from "wds/badge";
import _axBadge from "ax/badge";
import _wdsStarRatings from "wds/starRatings";
import _wdsButton from "wds/button";
import _listingReportAbuse from "listing/reportAbuse";
import _wdsComment from "wds/comment";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<a${"a0:href"} target="_blank"${3}><span type-style="body-2" class="bolded${0}"${2}>${"t2"}</span></a>`;
const $fragment2 = parseFragment`<span type-style="body-2" class="bolded${0}"${2}>${"t1"}</span>`;
const $fragment3 = parseFragment`<a href="javascript:;"${3}>${"t1"}</a>`;
const $fragment4 = parseFragment`<span type-style="body-3" class="right-align${0}"${2}>${"t1"}</span>`;
const $fragment5 = parseFragment`<div${3}><p type-style="body-3" class="review-content bolded${0}"${2}>${"t2"}</p><p type-style="body-3" class="review-content${0}"${2}>${"t4"}</p></div>`;
const $fragment6 = parseFragment`<span type-style="body-3" class="likes${0}"${2}>${"t1"}</span>`;
const $fragment7 = parseFragment`<div class="divider comment${0}" role="separator"${2}></div>`;
const $fragment8 = parseFragment`<div class="flex-container comment-box${0}"${2}><label${"a1:for"}${3}><span type-style="body-2"${3}>${"t3"}</span></label><textarea${"a4:id"} name="comment"${3}></textarea></div>`;
const $fragment9 = parseFragment`<div class="divider${0}"${2}></div>`;
const stc0 = {
  classMap: {
    "review-item": true
  },
  key: 0
};
const stc1 = {
  classMap: {
    "flex-container": true
  },
  key: 1
};
const stc2 = {
  key: 2
};
const stc3 = {
  classMap: {
    "flex-container": true,
    "header": true
  },
  key: 6
};
const stc4 = {
  classMap: {
    "flex-container": true
  },
  key: 7
};
const stc5 = {
  "left-spacing": true
};
const stc6 = {
  slotAssignment: "label",
  classMap: {
    "label": true
  },
  attrs: {
    "type-style": "body-3"
  },
  key: 17
};
const stc7 = {
  attrs: {
    "name": "label"
  },
  key: 18
};
const stc8 = {
  classMap: {
    "right-align": true
  },
  attrs: {
    "type-style": "body-3"
  },
  key: 19
};
const stc9 = {
  attrs: {
    "data-testid": "review-date-link"
  },
  key: 20
};
const stc10 = {
  classMap: {
    "flex-container": true,
    "footer": true
  },
  key: 27
};
const stc11 = {
  "comment-button": true
};
const stc12 = {
  "data-testid": "comment-button"
};
const stc13 = {
  "like-button": true
};
const stc14 = {
  "data-testid": "like-button"
};
const stc15 = {
  "report-abuse-btn": true
};
const stc16 = {
  "data-testid": "report-abuse-btn"
};
const stc17 = [];
const stc18 = {
  classMap: {
    "flex-container": true,
    "comment-box-container": true
  },
  key: 37
};
const stc19 = {
  classMap: {
    "flex-container": true
  },
  key: 38
};
const stc20 = {
  classMap: {
    "flex-container": true,
    "actions-container": true
  },
  key: 43
};
const stc21 = {
  "cancel-comment-btn": true
};
const stc22 = {
  "data-testid": "close-comment-btn"
};
const stc23 = {
  "data-testid": "post-comment-btn"
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {fid: api_scoped_frag_id, c: api_custom_element, h: api_element, d: api_dynamic_text, sp: api_static_part, st: api_static_fragment, k: api_key, i: api_iterator, f: api_flatten, t: api_text, s: api_slot, b: api_bind, gid: api_scoped_id} = $api;
  const {_m0, _m1, _m2, _m3, _m4, _m5, _m6, _m7} = $ctx;
  return [api_element("div", stc0, api_flatten([api_element("div", stc1, [$cmp.hasProfileLink ? api_custom_element("wds-link", _wdsLink, stc2, [api_element("a", {
    attrs: {
      "href": api_scoped_frag_id($cmp.review.user.profileLink),
      "target": "_blank",
      "aria-label": $cmp.avatarLinkAriaLabel
    },
    key: 3
  }, [api_custom_element("wds-avatar", _wdsAvatar, {
    props: {
      "src": $cmp.review.user.avatar
    },
    key: 4
  })])]) : null, !$cmp.hasProfileLink ? api_custom_element("wds-avatar", _wdsAvatar, {
    props: {
      "src": $cmp.review.user.avatar,
      "alt": $cmp.defaultAvatarAltText
    },
    key: 5
  }) : null, api_element("div", stc3, [api_element("div", stc4, api_flatten([$cmp.hasProfileLink ? api_static_fragment($fragment1, 9, [api_static_part(0, {
    attrs: {
      "href": api_scoped_frag_id($cmp.review.user.profileLink)
    }
  }, null), api_static_part(2, null, api_dynamic_text($cmp.reviewerName))]) : null, !$cmp.hasProfileLink ? api_static_fragment($fragment2, 11, [api_static_part(1, null, api_dynamic_text($cmp.reviewerName))]) : null, !$cmp.hasProfileLink ? $cmp.isLegacyReviewer ? api_custom_element("wds-popover-tooltip", _wdsPopoverTooltip, {
    props: {
      "tooltipData": $cmp.reviewLabels.legacyReviewerTooltip
    },
    key: 12
  }) : null : null, api_iterator($cmp.review.user.badges, function (badge) {
    return api_element("div", {
      classMap: stc5,
      key: api_key(13, badge.iteratorKey)
    }, [badge.i18nFn ? api_custom_element("wds-badge", _wdsBadge, {
      props: {
        "badge": badge
      },
      key: 14
    }) : null, !badge.i18nFn ? api_custom_element("ax-badge", _axBadge, {
      props: {
        "text": badge.value,
        "theme": badge.variant
      },
      key: 15
    }) : null]);
  })])), api_custom_element("wds-star-ratings", _wdsStarRatings, {
    props: {
      "value": $cmp.review.rating,
      "size": "small",
      "spaceBetween": "xsmall",
      "labelPosition": "bottom",
      "readOnly": true
    },
    key: 16
  }, [api_element("span", stc6, [api_slot("label", stc7, [api_text(api_dynamic_text($cmp.starsLabel))], $slotset)])])]), !$cmp.isSingleReview ? api_element("div", stc8, [api_custom_element("wds-link", _wdsLink, stc9, [api_static_fragment($fragment3, 22, [api_static_part(0, {
    on: {
      "click": _m1 || ($ctx._m1 = api_bind($cmp.handleSingleReview))
    }
  }, null), api_static_part(1, null, api_dynamic_text($cmp.review.date))])])]) : null, $cmp.isSingleReview ? api_static_fragment($fragment4, 24, [api_static_part(1, null, api_dynamic_text($cmp.review.date))]) : null]), api_static_fragment($fragment5, 26, [api_static_part(2, null, api_dynamic_text($cmp.review.title)), api_static_part(4, null, api_dynamic_text($cmp.review.content))]), api_element("div", stc10, [api_custom_element("wds-button", _wdsButton, {
    classMap: stc11,
    attrs: stc12,
    props: {
      "size": "small",
      "variant": "secondary",
      "ariaExpanded": $cmp.showCommentBox,
      "label": $cmp.sharedLabels.comment
    },
    key: 28,
    on: {
      "click": _m2 || ($ctx._m2 = api_bind($cmp.openCommentCreator))
    }
  }), api_custom_element("wds-button", _wdsButton, {
    classMap: stc13,
    attrs: stc14,
    props: {
      "size": "small",
      "variant": $cmp.likeVariant,
      "disabled": $cmp.isLiking,
      "ariaPressed": $cmp.isLiked,
      "ariaLabel": $cmp.reviewLabels.like,
      "icon": "like"
    },
    key: 29,
    on: {
      "click": _m3 || ($ctx._m3 = api_bind($cmp.handleLike))
    }
  }), api_static_fragment($fragment6, 31, [api_static_part(1, null, api_dynamic_text($cmp.dynamicLabels.likeCount))]), api_custom_element("wds-button", _wdsButton, {
    classMap: stc15,
    attrs: stc16,
    props: {
      "size": "small",
      "variant": "tertiary",
      "label": $cmp.reviewLabels.reportAbuseBtn
    },
    key: 32,
    on: {
      "click": _m4 || ($ctx._m4 = api_bind($cmp.handleOpenReportAbuse))
    }
  }), $cmp.isModalShown ? api_custom_element("listing-report-abuse", _listingReportAbuse, {
    props: {
      "reviewId": $cmp.review.id,
      "closedFocusTarget": $cmp.reportAbuseButtonRef
    },
    key: 33,
    on: {
      "close": _m5 || ($ctx._m5 = api_bind($cmp.toggleModal))
    }
  }) : null]), $cmp.review.comments ? api_iterator($cmp.review.comments, function (itValue, itIndex, itFirst, itLast) {
    const it = {
      value: itValue,
      index: itIndex,
      first: itFirst,
      last: itLast
    };
    return [api_custom_element("wds-comment", _wdsComment, {
      props: {
        "comment": it.value,
        "isMobile": $cmp.isMobile
      },
      key: api_key(34, it.value.id)
    }), !it.last ? api_static_fragment($fragment7, api_key(36, it.value.id)) : null];
  }) : stc17, $cmp.showCommentBox ? api_element("div", stc18, [api_element("div", stc19, [api_element("a", {
    attrs: {
      "href": api_scoped_frag_id($cmp.userProfile.profileUrl),
      "aria-label": $cmp.avatarLinkAriaLabel
    },
    key: 39
  }, [api_custom_element("wds-avatar", _wdsAvatar, {
    props: {
      "src": $cmp.userProfile.avatar
    },
    key: 40
  })]), api_static_fragment($fragment8, 42, [api_static_part(1, {
    attrs: {
      "for": api_scoped_id("comment")
    }
  }, null), api_static_part(3, null, api_dynamic_text($cmp.reviewLabels.commentHeader)), api_static_part(4, {
    attrs: {
      "id": api_scoped_id("comment")
    }
  }, null)])]), api_element("div", stc20, [api_custom_element("wds-button", _wdsButton, {
    classMap: stc21,
    attrs: stc22,
    props: {
      "size": "small",
      "variant": "secondary",
      "label": $cmp.sharedLabels.cancel
    },
    key: 44,
    on: {
      "click": _m6 || ($ctx._m6 = api_bind($cmp.closeCommentCreator))
    }
  }), api_custom_element("wds-button", _wdsButton, {
    attrs: stc23,
    props: {
      "size": "small",
      "disabled": $cmp.isCommenting,
      "label": $cmp.sharedLabels.comment
    },
    key: 45,
    on: {
      "click": _m7 || ($ctx._m7 = api_bind($cmp.commentReview))
    }
  })])]) : null])), !$cmp.isSingleReview ? api_static_fragment($fragment9, 47) : null];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.slots = ["label"];
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-5ebu85iqs2n";
tmpl.legacyStylesheetToken = "undefined-_review";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
